<section class="raci-template-search-area-search-form">
    <div class="search-label">
        <label>{{'calculationModel.name' | translate | uppercase}}</label>
        <kendo-textbox #nameField style="width:100%" class="search-field" [(ngModel)]="searchModel.name"
            (ngModelChange)="triggerSearch()">
        </kendo-textbox>
    </div>
</section>
